import React from 'react';
import './icon-with-background.css';

export const IconWithBackground = ({ 
  icon, 
  variant = 'default',
  size = 'medium',
  className = '' 
}) => {
  const sizeClasses = {
    'large': 'w-10 h-10 p-2',
    'medium': 'w-8 h-8 p-1.5',
    'small': 'w-6 h-6 p-1'
  };

  const variantClasses = {
    'default': 'bg-neutral-50 text-neutral-600',
    'warning': 'bg-warning-50 text-warning-600',
    'error': 'bg-error-50 text-error-600',
    'success': 'bg-success-50 text-success-600'
  };

  return (
    <div className={`icon-with-background ${sizeClasses[size]} ${variantClasses[variant]} ${className}`}>
      {icon}
    </div>
  );
}; 